"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.PageBack = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/slicedToArray"));

var _jsxRuntime = require("react/jsx-runtime");

var _react = require("@fluentui/react");

var _Button = require("@fluentui/react/lib/Button");

var React = _interopRequireWildcard(require("react"));

var _reactRouterDom = require("react-router-dom");

var getClassNames = (0, _react.classNamesFunction)();

var PageBackBase = function PageBackBase(_ref) {
  var _subComponentStyles$b;

  var className = _ref.className,
      _ref$path = _ref.path,
      path = _ref$path === void 0 ? '/' : _ref$path,
      styles = _ref.styles,
      children = _ref.children;

  var _getClassNames = getClassNames(styles),
      subComponentStyles = _getClassNames.subComponentStyles;

  var _useState = (0, React.useState)(),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      history = _useState2[0],
      setHistory = _useState2[1];

  var onRouteRender = (0, React.useCallback)(function (_ref2) {
    var newHistory = _ref2.history;
    setHistory(newHistory);
    return null;
  }, []);
  var onClick = (0, React.useCallback)(function () {
    history === null || history === void 0 ? void 0 : history.push(path);
  }, [history]);
  children = React.Children.count(children) > 0 ? children : 'Back';
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactRouterDom.Route, {
      render: onRouteRender
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.ActionButton, {
      className: (0, _react.css)('ms-PageBack', className),
      iconProps: {
        iconName: 'back'
      },
      onClick: onClick,
      styles: (_subComponentStyles$b = subComponentStyles.button) === null || _subComponentStyles$b === void 0 ? void 0 : _subComponentStyles$b.call(subComponentStyles, {}),
      children: children
    })]
  });
};

var PageBack = (0, _react.styled)(PageBackBase, {
  subComponentStyles: {
    button: {
      root: {
        paddingLeft: 0
      },
      icon: {
        marginLeft: 0
      }
    }
  }
});
exports.PageBack = PageBack;